
import { IMapFiltrableProperties } from "@common-modules/wlm-map/generic-map/models/map-filtrable-properties";
import { CTMapNamespace } from "./ct-map-namespace";
import { CTLayerItemType } from "./ct-map.constants";

export class CTMapFiltrableProperties implements IMapFiltrableProperties {
  type = CTLayerItemType;
  neType: string;
  namespaces: CTMapNamespace[];
  layerIds: string[];

  constructor(init: {
    neType: string;
    namespaces: CTMapNamespace[];
    layerIds: string[];
  }) {
    Object.assign(this, init);
  }
}
